import { useMemo } from 'react';
import moment from 'moment';
import { convertDegrees2Meters } from 'utils/convertors';
import { ASSET_BOUNDS_DISTANCE, ASSET_TIME_FRAME } from 'config';

// Take center point and add ~2km radius for now
const useAssetBounds = siteReport =>
  useMemo(() => {
    const centerLat = siteReport?.lat;
    const centerLon = siteReport?.lon;

    if (centerLat && centerLon) {
      const [centerX, centerY] = convertDegrees2Meters(centerLon, centerLat);
      const from = moment
        .utc(siteReport?.startTime)
        .subtract(ASSET_TIME_FRAME, 'minutes');
      const to = moment
        .utc(siteReport?.startTime)
        .add(siteReport?.duration, 'seconds')
        .add(ASSET_TIME_FRAME, 'minutes');

      return {
        from: from.toISOString(),
        to: to.toISOString(),
        xMin: centerX - ASSET_BOUNDS_DISTANCE,
        xMax: centerX + ASSET_BOUNDS_DISTANCE,
        yMin: centerY - ASSET_BOUNDS_DISTANCE,
        yMax: centerY + ASSET_BOUNDS_DISTANCE
      };
    }
    return {
      xMin: 0,
      yMin: 0,
      xMax: 0,
      yMax: 0
    };
  }, [siteReport]);

export default useAssetBounds;
